import http from '../lib/api'
import {monitor} from '../lib/monitor'

/**
 * service基类
 */
export class Base {
  constructor() {

  }

  /**
   *
   * @param service
   * @param data
   * @param headers
   * @param {Object} options
   * @param {boolean} [options.showError = true] 是否显示toast
   * @param {boolean} [options.noloading = true] 是否显示loading
   * @returns {Promise<T | T>}
   */
  async $http(service, data = {}, headers = {}, options = {}) {
    let loading;

    // if (!options.noloading) loading = weuijs.loading('加载中...');

    function requestLoadingEmit(value) {
      if (!options.noloading) bus.$emit('requestLoading', value);
    }


    requestLoadingEmit(service);


    return await http(service, data, headers).then(res => {
      // loading && loading.hide();
      requestLoadingEmit(false);
      if (res.code != '0' && options.showError !== false) bus.$emit('msg', res.msg || res.code);
      return res;
    }).catch(error => {
      // loading && loading.hide();
      requestLoadingEmit(false);
      const config = error.config;
      let msg = "";
      if (config && config.url) msg += config.url + "：";
      msg += error.toString();
      monitor.api(service, false, 0, 500, msg);
      Log('service error');
      console.error(error);
      return {code: '500', msg: '响应异常'}
    });
  }
}

export const OkHttp = new Base();



// WEBPACK FOOTER //
// ./src/services/base.js